<template>
  <div class="grid">
    <!-- MEMBERSHIP DRIVE 2026 — remove this banner after May -->
    <a href="https://withfriends.co/dublab/join" class="membership-banner">
      Sign Up to be a Member for Event Discounts &amp; More
    </a>
    <!-- END MEMBERSHIP DRIVE 2026 -->
    <div class="day-filter" v-if="selectedDay">
      <span>{{ selectedDayLabel }}</span>
      <router-link to="/events">Show upcoming</router-link>
    </div>
    <p class="day-empty" v-if="selectedDay && !featured.length">
      No events on this date.
    </p>
    <Flickity
      class="flickity"
      ref="flickity"
      :key="listKey"
      v-if="featured.length"
      v-on:init="flickityInit"
      :options="flickityOptions"
    >
      <Feature
        v-for="feature in featured"
        type="event"
        :page="feature"
        :key="feature.url"
      ></Feature>
    </Flickity>
    <div class="calendars" :style="{ gridTemplateColumns: 'repeat(' + monthsVisible + ', 1fr)' }">
      <button
        class="icon icon-button-arrow left"
        @click="calendarPaginate(-1)"
        v-if="hasPrev"
      ></button>
      <button
        class="icon icon-button-arrow right"
        @click="calendarPaginate(1)"
        v-if="hasNext"
      ></button>
      <Calendar
        v-for="(calendar, i) in calendars"
        :active="day"
        :month="calendar"
        :key="i"
      ></Calendar>
    </div>
    <BoxDonate></BoxDonate>
  </div>
</template>

<script>
import BoxDonate from '@/components/BoxDonate'
import Calendar from '@/components/Calendar'
import Feature from '@/components/Feature'
import { mixin } from '@/lib/content-state'
import Flickity from 'vue-flickity'
import delve from 'dlv'

export default {
  name: 'Events',
  components: { Flickity, Calendar, Feature, BoxDonate },
  mixins: [ mixin ],
  data () {
    return {
      flickityOptions: {
        autoPlay: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left',
        lazyLoad: 4
      },
      monthsVisible: 4,
    }
  },
  created () {
    window.addEventListener('resize', this.resize, false)
    if (!this.monthActiveIndex) this.monthActiveIndex = this.page.currentIndex
    this.resize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize, false)
  },
  computed: {
    day () {
      const today = new Date()
      let dd = today.getDate()
      if (dd < 10) dd = '0' + dd
      let mm = today.getMonth() + 1
      if (mm < 10) mm = '0' + mm
      return this.$route.query.day
        ? this.$route.query.day
        : [today.getFullYear(), mm, dd].join('-')
    },
    monthActiveIndex: {
      get () {
        return this.$store.state.ui.monthActiveIndex
      },
      set (value) {
        this.$store.dispatch('updateUi', { monthActiveIndex: value })
      }
    },
    selectedDay () {
      return this.$route.query.day || null
    },
    selectedDayLabel () {
      const parts = (this.selectedDay || '').split('-').map(Number)
      if (parts.length !== 3 || parts.some(isNaN)) return this.selectedDay
      const date = new Date(parts[0], parts[1] - 1, parts[2])
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      })
    },
    // rebuilds Flickity when the cell set changes; it does not
    // pick up slot changes on its own
    listKey () {
      return this.selectedDay || 'featured'
    },
    featured () {
      // a `?day=` request returns that day's events as `pages`,
      // not as `featured`
      if (this.selectedDay) return this.qpages
      return this.$store.getters.getPages(delve(this, 'page.featured'))
    },
    calendars () {
      const calendars = delve(this, 'page.calendars')
      if (calendars) {
        const output = new Array(this.monthsVisible)
          .fill('')
          .map((data, i) => this.page.calendars[this.monthActiveIndex + i])
          .filter(p => p)
        return output
      } else return []
    },
    hasNext () {
      if (!this.page.calendars) return false
      return this.monthActiveIndex < this.page.calendars.length  - this.monthsVisible
    },
    hasPrev () {
      if (!this.page.calendars) return false
      return this.monthActiveIndex > 1
    }
  },
  methods: {
    resize () {
      this.monthsVisible = Math.floor(window.innerWidth / 300)
    },
    calendarPaginate (amount) {
      const nextIndex = this.monthActiveIndex + amount
      if (nextIndex > 0 && nextIndex <= this.page.calendars.length - this.monthsVisible) {
        this.monthActiveIndex = nextIndex
      }
    },
    flickityInit () {
      this.$refs.flickity.on('dragStart', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'none'
      })
      this.$refs.flickity.on('dragEnd', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'auto'
      })
    }
  }
}
</script>

<style scoped>
/* MEMBERSHIP DRIVE 2026 — remove this block after May */
.membership-banner {
  grid-column: 1 / -1;
  display: block;
  background-color: #6699ff;
  color: #fff;
  text-align: center;
  padding: 1.5rem 2rem;
  border-radius: var(--br1);
  font: var(--medium);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-decoration: none;
  margin-bottom: 1rem;
  transition: opacity 0.15s ease;
}

.membership-banner:hover {
  opacity: 0.85;
}
/* === END MEMBERSHIP DRIVE 2026 === */

.day-filter {
  grid-column: 1 / -1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 2rem;
  font: var(--small);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 1rem;
}

.day-filter a {
  text-decoration: underline;
}

.day-empty {
  grid-column: 1 / -1;
  margin-bottom: 2rem;
}

.calendars {
  display: grid;
  grid-column-gap: 2rem;
  grid-column: 1 / -1;
  position: relative;
}

.calendars button {
  margin: 1rem;
  position: absolute;
  top: 0;
  z-index: 2;
}

.calendars button.right {
  right: 0;
}

.Calendar {
  grid-column: 1fr;
}

.flickity {
  grid-column: 1 / -1;
  margin-left: -2rem;
  margin-right: -2rem;
}

.Feature-Container { 
  padding-left: 2rem; 
  padding-right: 2px;
  width: 40vw; 
}

@media (max-width: 1280px) {
  .Feature-Container { width: 46vw; }
}

@media (max-width: 1000px) {
  .Feature-Container { width: 30rem; }
}
</style>
